module.exports = __webpack_public_path__ + "static/media/details-1-image-1.91d65fdf.jpg";